export default __webpack_public_path__ + "static/media/bookings-tab.015c64af.png";